import { Toast } from '../../../../components/Common/Toast';
import { HTTPStatusEnum } from '../../../../interfaces/log.interface';
import { callAPI } from '../../../../services/api.service';

export interface ProjectTemplateModel {
  id: string;
  name: string;
  wpProjectId: string;
  isActive: boolean;
  wpTitle?: string;
  wpExcerpt?: string;
  wpLink?: string;
  wpDateList?: string;
  wpSyncedAt?: any;
  createdAt?: any;
  updatedAt?: any;
}

export const getAdminProjectTemplates = async (
  page?: number,
  search?: string,
): Promise<{ templates: ProjectTemplateModel[]; totalPages: number; totalRecords: number }> => {
  try {
    const params = new URLSearchParams();
    if (page) params.set('pageNumber', String(page));
    if (search) params.set('search', search);
    const qs = params.toString() ? `?${params.toString()}` : '';
    const response = await callAPI(`admin/project-template${qs}`);
    if (response?.templates) {
      return {
        templates: response.templates,
        totalPages: response.totalPages ?? 0,
        totalRecords: response.totalRecords ?? 0,
      };
    } else {
      Toast('Failed to get project templates', true);
      return { templates: [], totalPages: 0, totalRecords: 0 };
    }
  } catch (error) {
    Toast('Failed to get project templates', true);
    return { templates: [], totalPages: 0, totalRecords: 0 };
  }
};

export const saveProjectTemplate = async (
  data: { wpProjectId: string },
  onSuccess: () => void
) => {
  try {
    const response = await callAPI('admin/project-template/save', data);
    if (response?.status === HTTPStatusEnum.OK) {
      Toast('Project Template created successfully');
      onSuccess();
    } else {
      Toast(response?.message || 'Failed to create project template', true);
    }
  } catch (error) {
    Toast('Failed to create project template', true);
  }
};

export const updateProjectTemplate = async (
  data: { id: string; wpProjectId: string },
  onSuccess: () => void
) => {
  try {
    const response = await callAPI('admin/project-template/update', data);
    if (response?.status === HTTPStatusEnum.OK) {
      Toast('Project Template updated successfully');
      onSuccess();
    } else {
      Toast(response?.message || 'Failed to update project template', true);
    }
  } catch (error) {
    Toast('Failed to update project template', true);
  }
};

export const deleteProjectTemplate = async (id: string, onSuccess: () => void) => {
  try {
    const response = await callAPI('admin/project-template/delete', { id });
    if (response?.status === HTTPStatusEnum.OK) {
      Toast('Project Template deleted successfully');
      onSuccess();
    } else {
      Toast(response?.message || 'Failed to delete project template', true);
    }
  } catch (error) {
    Toast('Failed to delete project template', true);
  }
};

export const changeProjectTemplateStatus = async (id: string, onSuccess: () => void) => {
  try {
    const response = await callAPI('admin/project-template/status', { id });
    if (response?.status === HTTPStatusEnum.OK) {
      Toast('Project Template status updated successfully');
      onSuccess();
    } else {
      Toast(response?.message || 'Failed to update status', true);
    }
  } catch (error) {
    Toast('Failed to update project template status', true);
  }
};

export const syncProjectTemplateFromWP = async (id: string, onSuccess: () => void) => {
  try {
    const response = await callAPI('admin/project-template/sync-wp', { id });
    if (response?.status === HTTPStatusEnum.OK) {
      Toast('WordPress data synced successfully');
      onSuccess();
    } else {
      Toast(response?.message || 'Failed to sync WordPress data', true);
    }
  } catch (error) {
    Toast('Failed to sync WordPress data', true);
  }
};

export const clearProjectTemplateCache = async (id: string, onSuccess: () => void) => {
  try {
    const response = await callAPI('admin/project-template/clear-cache', { id });
    if (response?.status === HTTPStatusEnum.OK) {
      Toast('WordPress resource cache cleared');
      onSuccess();
    } else {
      Toast(response?.message || 'Failed to clear cache', true);
    }
  } catch (error) {
    Toast('Failed to clear WordPress cache', true);
  }
};
